export default __webpack_public_path__ + "static/media/sweat2.c531d285.png";